var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbDownSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3031_2867",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "black",
    fillOpacity: 0.6
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3031_2867)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.99984 2H10.6665V10.6667L5.99984 15.3333L5.1665 14.5C5.08873 14.4222 5.02484 14.3167 4.97484 14.1833C4.92484 14.05 4.89984 13.9222 4.89984 13.8V13.5667L5.63317 10.6667H1.99984C1.64428 10.6667 1.33317 10.5333 1.0665 10.2667C0.799837 10 0.666504 9.68889 0.666504 9.33333V8C0.666504 7.92222 0.674837 7.83889 0.691504 7.75C0.708171 7.66111 0.733171 7.57778 0.766504 7.5L2.7665 2.8C2.8665 2.57778 3.03317 2.38889 3.2665 2.23333C3.49984 2.07778 3.74428 2 3.99984 2ZM11.9998 10.6667V2H14.6665V10.6667H11.9998Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbDownSelected);
export default __webpack_public_path__ + "static/media/thumb_down_selected.f73b7d462055d43ef5061d917ced44f7.svg";
export { ForwardRef as ReactComponent };